"use strict";

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard3(require("react"));

var _component = _interopRequireDefault(require("@loadable/component"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Fallback = function Fallback(props) {
  return (0, _core.jsx)("svg", props);
};

var Icon = function Icon(props) {
  var type = props.type,
      other = (0, _objectWithoutProperties2["default"])(props, ["type"]);
  var FallbackIcon = (0, _core.jsx)(_Icon["default"], (0, _extends2["default"])({
    as: Fallback
  }, other));
  var IconType = (0, _react.useMemo)(function () {
    switch (type) {
      case 'Close':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Close'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Logistic':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Logistic'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Service':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Service'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'CashBatch':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/CashBatch'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Company':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Company'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'CalendarFrom':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/CalendarFrom'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'CalendarTo':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/CalendarTo'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'User':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/User'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Friends':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Friends'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Follow':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Follow'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Atm':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Atm'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Search':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Search'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Clock':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Clock'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'PhoneShake':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/PhoneShake'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'CardHeart':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/CardHeart'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Alert':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Alert'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Branch':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Branch'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Factory':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Factory'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Home':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Home'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'JudicialScales':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/JudicialScales'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'ChevronDoubleUp':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/ChevronDoubleUp'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'ChevronDoubleDown':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/ChevronDoubleDown'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Send':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Send'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Username':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Username'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'PhoneCall':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/PhoneCall'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'ServiceCounter':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/ServiceCounter'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Hammer':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Hammer'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Package':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Package'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'List':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/List'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'MapPinAlternate':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/MapPinAlternate'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Burger':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Burger'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Calculator':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Calculator'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Dialogue':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Dialogue'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Rocket':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Rocket'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Happy':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Happy'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Heart':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Heart'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Bell':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Bell'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'PlaybackPlayButton':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/PlaybackPlayButton'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'PlaybackPause':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/PlaybackPause'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'PlaybackPlay':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/PlaybackPlay'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'CircleCheckmark':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/CircleCheckmark'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Laptop':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Laptop'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Cash':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Cash'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Briefcase':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Briefcase'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'FirstAid':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/FirstAid'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Gavel':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Gavel'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'CashRegister':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/CashRegister'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Truck':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Truck'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'FirstAidKit':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/FirstAidKit'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Shop':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Shop'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'MapPin':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/MapPin'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'ChevronDown':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/ChevronDown'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'ChevronLeft':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/ChevronLeft'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'ChevronUp':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/ChevronUp'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Add':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Add'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'ThumbsUp':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/ThumbsUp'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'News':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/News'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Checkmark':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/Checkmark'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'ArrowLeft':
        return (0, _component["default"])(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require('../Icons/ArrowLeft'));
          });
        }, {
          fallback: FallbackIcon
        });

      default:
        return Fallback;
    }
  }, [type]);

  if (!type) {
    return null;
  }

  return (0, _core.jsx)(_Icon["default"], (0, _extends2["default"])({
    as: IconType
  }, other));
};

__signature__(Icon, "useMemo{IconType}");

var _default = Icon;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Fallback, "Fallback", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/Icon.tsx");
  reactHotLoader.register(Icon, "Icon", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/Icon.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/Icon.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();